import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
} from '@material-ui/core';

import ButtonClose from '../../../../../../../../../../util/buttonClose/.mixins/buttonClose';

export default (props) => {
    const { isModalOpen, handleDialogModal } = props;

    const HeaderModal = () => {
        return (
        <Typography
            variant='button'
            align='center'
            display='block'
            style={{ marginLeft: '20px', fontSize: '15px' }}
        >
            ENVIAR FICHA TÉCNICA    
            <ButtonClose closeMethod={handleDialogModal} />
        </Typography>
        );
    };

    const BodyModal = () => {
        return (
            <div align='center'>
                <Typography variant='subtitle1' align='center' gutterBottom>
                    A ficha técnica de produto foi enviada com sucesso!
                </Typography>
            </div>
        );
    };

    return (
        <Dialog open={isModalOpen} scroll='paper'>
            <DialogTitle>
                <HeaderModal />
            </DialogTitle>

            <DialogContent>
                <BodyModal />
            </DialogContent>
        </Dialog>
    );
}
